import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ResponsiveGridDirective } from '../grid/responsive-grid.directive';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LabeledTextboxModule } from './components/labeled-textbox/labeled-textbox.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldProvideReadonlyDirective } from './components/mat-form-field-provide-readonly.directive';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputRequiredDirective, MatSelectRequiredDirective } from './components/mat-form-field-required.directive';
import { DisableControlDirective } from './components/mat-form-field-dynamic-disable.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
    declarations: [
        ResponsiveGridDirective,
        MatFormFieldProvideReadonlyDirective,
        DisableControlDirective,

        MatSelectRequiredDirective,
        MatInputRequiredDirective,
    ],
    imports: [
        A11yModule,
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatSidenavModule,
        MatGridListModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatSliderModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatSnackBarModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatProgressBarModule,
        FlexLayoutModule,
        MatStepperModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDividerModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
    ],
    exports: [
        A11yModule,
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatSidenavModule,
        MatGridListModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatSliderModule,
        MatButtonToggleModule,
        FlexLayoutModule,
        MatDialogModule,
        MatSnackBarModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatProgressBarModule,
        MatStepperModule,
        MatExpansionModule,
        MatSlideToggleModule,
        LabeledTextboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDividerModule,
        MatTooltipModule,
        MatProgressSpinnerModule,

        ResponsiveGridDirective,
        MatFormFieldProvideReadonlyDirective,
        DisableControlDirective,

        MatSelectRequiredDirective,
        MatInputRequiredDirective,
    ],
})
export class MaterialModule {
}
